// export const server = 'http://localhost:2000'
export const server = 'https://service.apartmentrupas.com'
